import React from 'react'
import classnames from 'classnames'
import { parseDateWithStatus, parseDateWithTime } from '@/shared/helpers/string'
import styles from '../MobileTxRow.module.scss'

export function TransactionDetails({ title, createdAt, status, withoutDate, isError, txType }: {
  createdAt: string;
  isError: boolean;
  status: string;
  title: string;
  txType: string;
  withoutDate: boolean;
}) {
  const dateStatusText = !withoutDate
    ? parseDateWithStatus(createdAt, status)
    : isError
      ? (
        <>
          Declined
          <span className={styles.dot}>•</span>
        </>
      )
      : status === 'PENDING'
        ? 'Pending'
        : null

  return (
    <div className={styles.txDetails}>
      <p className={styles.txType}>{title}</p>
      <p className={classnames(styles.txUsdAmount, isError && styles.errorTx)}>
        {dateStatusText}
        {withoutDate && (txType === 'REVERSE' || txType === 'REFUND') && (
          <>
            <span>Reversal</span>
            {withoutDate && <span className={styles.dot}>•</span>}
          </>
        )}
        {withoutDate && txType === 'CLEARING' && (
          <>
            <span>Clearing</span>
            {withoutDate && <span className={styles.dot}>•</span>}
          </>
        )}
        {withoutDate && <span className={styles.time}>{parseDateWithTime(createdAt)}</span>}
      </p>
    </div>
  )
}
